/*添加服务*/
define('services/bi/bi.analytic.service',['app'], function (app) {
    return app.factory('biAnalyticService', ['UserInfo', function (UserInfo) {

        /**
         * 上报服务，上报数据给bi
         * @param interfaceName
         * @param settings
         */
        function bianalytic(interfaceName, settings) {
            // 先判断是否已经生效
            if (window.hianalytics != undefined) {
                if (interfaceName == 'OpenTrade.Server4User.getSettlement' && settings.req.billType == 'AP') {
                    bianalyticLink('我的账户 - 结算单查询', 1, 'DPRM0059');
                } else if (interfaceName == 'OpenTrade.Server4User.getSettlement' && settings.req.billType == 'AR') {
                    bianalyticLink('我的账户 - 账单查询', 1, 'DPRM0060');
                } else if (interfaceName == 'OpenTrade.Server4User.confirmSettlement' && settings.req.confirmType == '结算确认') {
                    // confirmType是额外增加的参数，删除掉
                    delete settings.req.confirmType;
                    bianalyticLink('我的账户 - 结算确认', 1, 'DPRM0019');
                } else if (interfaceName == 'OpenTrade.Server4User.confirmSettlement' && settings.req.confirmType == '账单确认') {
                    // confirmType是额外增加的参数，删除掉
                    delete settings.req.confirmType;
                    bianalyticLink('我的账户 - 账单确认', 1, 'DPRM0061');
                } else if (interfaceName == 'OpenTrade.Server4User.createDispute') {
                    bianalyticLink('我的账户 - 提交争议', 1, 'DPRM0020');
                } else if (interfaceName == 'OpenTrade.Server4User.getHistorySettlement') {
                    bianalyticLink('我的账户 - 结算单查询', 1, 'DPRM0062');
                }

            }
        }

        /**
         * 上报服务，上报数据给bi，给其他非接口交互使用
         * @param interfaceName
         * @param serviceItem
         * @param tagType
         */
        function bianalyticLink(interfaceName, serviceItem, tagType, clueExtendInfo) {
            // 先判断是否已经生效
            if (window.hianalytics != undefined) {
                hianalytics.initArr();
                hasdk.push(['setTitle', "管理中心 - " + interfaceName]);
                hasdk.setTitle("管理中心 - " + interfaceName);
                if (tagType == "CMMT0006") {
                    hasdk.push(['setTitle', "管理中心FAQ - " + interfaceName]);
                    hasdk.setTitle("管理中心FAQ - " + interfaceName);
                }
                // 增加扩展信息
                if (serviceItem) {
                    hianalytics.setCustomVariable("serviceItem", serviceItem);
                } else {
                    hianalytics.setCustomVariable("serviceItem", 1);
                }
                if (tagType) {
                    hianalytics.setCustomVariable("tagType", tagType);
                }

                if (clueExtendInfo) {
                    hianalytics.trackLink("", "", "", clueExtendInfo);
                } else {
                    trackLinkToBi();
                }

            }
        }

        /**
         * 上报消息给bi
         */
        function trackLinkToBi() {
            if (sysUrlCfg.bianalyticUrl.isReport == 'true') {
                hianalytics.trackLink();
            }
        }

        function trackPageView(titleStr, tagType, serviceItem) {
            if (window.hianalytics != undefined) {
                hianalytics.initArr();
                if (titleStr) {
                    hasdk.setTitle("管理中心 - " + titleStr);
                }
                if (tagType) {
                    hianalytics.setCustomVariable("tagType", tagType);
                }
                if (serviceItem) {
                    hianalytics.setCustomVariable("serviceItem", serviceItem);
                } else {
                    hianalytics.setCustomVariable("serviceItem", 1);
                }
                hianalytics.trackPageView();
            }
        }


        return {
            'bianalytic': bianalytic,
            'bianalyticLink': bianalyticLink,
            'trackPageView': trackPageView
        };
    }]);
});

